import { supabase } from '~/lib/supabase'

export async function getInvoiceDetails(userId: string) {
  const { data, error } = await supabase
    .from('invoicing_details')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false })

  if (error) {
    console.error('Error fetching invoices:', error)
    return []
  }

  return data
}
